export default __webpack_public_path__ + "static/puertoraiz-balthazaurus-scroll-7a44979522040642617095040695b2e3.mp4";